<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "longitude":"113.158978",
                "latitude":"23.046084",
                "radius":"200"
            },
            responseCode:  {"data":{"parkList":[{"address":"深海路","desc":"","eptCarports":49,"latitude":"23.036155","longitude":"113.14956","parkCode":"2KNTYVWC","parkName":"开发停车场2","totalCarports":100},{"address":"佛山市南海区桂城街道办南一路39号附近","desc":"","eptCarports":159,"latitude":"23.070148","longitude":"113.140698","parkCode":"2KKN6APO","parkName":"罗桂才测试停车场","totalCarports":525},{"address":"佛山市南海区桂平西路6号","desc":"","eptCarports":1994,"latitude":"23.038753","longitude":"113.165496","parkCode":"2KKN885S","parkName":"昌俊停车场","totalCarports":380},{"address":"佛山桂城瀚天科技城A三中庭","conTel":"13202405667","desc":"每小时3.00元","eptCarports":42,"latitude":"23.033085","longitude":"113.180453","parkCode":"2KKN6111","parkName":"开发测试停车场","totalCarports":42},{"address":"信息公园","desc":"534534","eptCarports":1490,"latitude":"23.033827","longitude":"113.181468","parkCode":"2KM43Y461","parkName":"ake测试停车场","totalCarports":1000}],"total":5},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取区域内所有停车场空车位信息",
                t_url: this.commonUrls.test+"getAreaEpt",
                p_url: this.commonUrls.prod+"getAreaEpt",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'longitude', info2: '是', info3: 'String', info4: '经度' },
                        { info1: 'latitude', info2: '是', info3: 'String', info4: '纬度' },
                        { info1: 'radius', info2: '是', info3: 'Decimal', info4: '半径，单位米，2位小数' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'int', info4: '记录条数' },
                        { info1: 'parkList', info2: '是', info3: 'JSONArray', info4: '停车场信息列表' }
                        ]
                },{
                    titleName: 'parkList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'address', info2: '是', info3: 'String', info4: '停车场地址' },
                        { info1: 'longitude', info2: '是', info3: 'String', info4: '经度' },
                        { info1: 'latitude', info2: '是', info3: 'String', info4: '纬度' },
                        { info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
                        { info1: 'totalCarports', info2: '是', info3: 'Integer', info4: '总车位数' },
                        { info1: 'eptCarports', info2: '是', info3: 'Integer', info4: '空车位数' },
                        { info1: 'conTel', info2: '是', info3: 'String', info4: '联系电话' },
                        { info1: 'stopConnectPlatform', info2: '否', info3: 'Integer', info4: '是否连接平台(上下架)0下架1上架' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getAreaEpt.vue